import {SET_STROKE} from "../constants/action-types";
import Mediator from "../services/Mediator";
import isTransparent from "../services/lib/is-transparent";

export const setStroke = ({stroke, strokeWidth}) => (dispatch) => {
  const value = {
    stroke:
      stroke !== `transparent` && (!stroke || isTransparent(stroke))
        ? `#000`
        : stroke,
    strokeWidth
  };
  dispatch({
    type: SET_STROKE,
    payload: {
      value
    }
  });
  Mediator.setStrokeToActive(value);
};
